// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6650":"a90a853a","8438":"a90a853a"}[chunkId] + ".chunk.css";
};